import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import styles from './DynamicPagesList.module.scss';
import {
  pagesListSelector,
  menuListSelector,
} from '../../redux/selectors/common-selectors';
import { setMenuSlug } from '../../redux/actions/menu-list-actions-creator';
import EventsList from '../../components/EventsList/EventsList';
import ContentNotFound from '../../components/content-not-found/ContentNotFound';
import { getMenuNameBySlug } from '../../utils/menu-utils';

const DynamicPagesList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: slug } = useParams();
  const menuList = useSelector(menuListSelector);
  const pagesList = useSelector(pagesListSelector);
  const [sectionName, setSectionName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    const sectionMenuName = getMenuNameBySlug(menuList, slug);

    if (sectionMenuName?.name) setSectionName(sectionMenuName.name);
    if (sectionMenuName?.description)
      setDescription(sectionMenuName.description);

    dispatch(setMenuSlug(slug));
  }, [dispatch, slug, location, menuList]);

  if (pagesList.length === 0) return <ContentNotFound />;

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.upperLine} />
      <h1>{sectionName}</h1>
      <p>{description}</p>
      <EventsList events={pagesList} isEveryEventLink />
    </div>
  );
};

export default DynamicPagesList;
